import React from "react";
import "./style.css";

const Input = ({ value, onChange, type, placeholder, style, className }) => {
  return (
    <input
      className={`input-box body1 dark-grey ${className}`}
      value={value}
      onChange={onChange}
      type={type}
      placeholder={placeholder}
      style={style}
    />
  );
};

export default Input;
